"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupEventLogService = exports.setupAxiosInterceptors = exports.getUnknownError = exports.buildRequestData = exports.logAnalyticsEvent = exports.logNetworkEvent = exports.isLogEventUrl = void 0;
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2021 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
// utilities used for consuming services
const enums_1 = require("../../enums");
const config_1 = require("../config");
const logger = __importStar(require("../../logging/logger"));
const event_log_service_1 = require("../../eventlog/event-log-service");
const app_constants_1 = require("../../app-constants");
// instance of <code>EventLogService</code> used for logging to splunk.
let eventLogService = {};
/**
 *
 * @param config
 * @param apiRequest
 */
function buildHeaders(config, apiRequest) {
    return Object.assign(Object.assign({}, config.commonHeaders), apiRequest.customHeaders);
}
/**
 *
 * @param config: ApiConfig
 * @param apiRequest: apiRequest
 * @param requestOptions: ApiRequestOptions: default { isSessionTokenRequired: true }
 *
 */
function buildLedsHeaders(config, apiRequest, requestOptions = { isSessionTokenRequired: true }) {
    const headers = Object.assign(Object.assign({}, config.commonHeaders), apiRequest.customHeaders);
    let isRegionPresent = false;
    if (config) {
        if (config.region && config.region.trim().length > 0) {
            isRegionPresent = true;
        }
        headers['Content-Type'] = 'application/json;charset=UTF-8';
        headers['Accept'] = 'application/json';
        headers['X-IBM-Client-ID'] = config.clientId;
        if (requestOptions.isSessionTokenRequired
            && requestOptions.jwtFromLeds) {
            headers['Authorization'] = 'Bearer ' + requestOptions.jwtFromLeds;
        }
        // if the region is present then only add it to the headers
        // if an empty region is sent (the region is empty in QA and PROD)
        // then LEDS service call fails
        if (isRegionPresent) {
            headers['X-Region'] = config.region;
        }
    }
    return headers;
}
/**
 * Builds the request and headers
 * @param apiConfig: ApiConfig
 * @param apiRequest: apiRequest
 * @param requestOptions: ApiRequestOptions, default values
 *                 isLedsRequest: false
 *                 isSessionTokenRequired: false
 *
 */
function buildRequestData(apiConfig, apiRequest, requestOptions = {
    isLedsRequest: false,
    isSessionTokenRequired: false
}) {
    const config = {
        baseURL: apiConfig.baseUrl,
        url: apiRequest.url,
        method: apiRequest.method,
        headers: requestOptions.isLedsRequest
            ? buildLedsHeaders(apiConfig, apiRequest, requestOptions)
            : buildHeaders(apiConfig, apiRequest),
        timeout: apiConfig.timeout ? apiConfig.timeout : 60000
    };
    if (apiRequest.method === enums_1.HttpMethod.GET) {
        if (apiRequest.params) {
            config.params = apiRequest.params;
        }
    }
    else if (apiRequest.method === enums_1.HttpMethod.POST
        || apiRequest.method === enums_1.HttpMethod.PUT
        || apiRequest.method === enums_1.HttpMethod.PATCH
        || apiRequest.method === enums_1.HttpMethod.DELETE) {
        if (apiRequest.data) {
            config.data = apiRequest.data;
        }
    }
    else {
        console.error(`unsupported HttpMethod ${apiRequest.method} received`);
        return null;
    }
    if (apiRequest.responseType) {
        config.responseType = apiRequest.responseType;
    }
    return config;
}
exports.buildRequestData = buildRequestData;
/**
 *
 * @param message: string the additional information
 */
function getUnknownError(message) {
    const customError = {
        status: 500,
        statusText: 'Unknown Error',
        message: message
    };
    return { response: customError };
}
exports.getUnknownError = getUnknownError;
/**
 * Sets up the axios interceptors for logging to splunk.
 * We do not log the event log url itself, or the first call to get attributes (required to create an event).
 *
 * @param apiConfig api configuration object contains event url, and enabled/disabled flag
 */
function setupAxiosInterceptors(apiConfig, commServicesAuthConfig) {
    setupEventLogService(apiConfig, commServicesAuthConfig);
    /*
     * Add axios request and response interceptors responsible for logging network type events
     */
    (() => __awaiter(this, void 0, void 0, function* () {
        config_1.axios.interceptors.request.use((config) => {
            if (config === null || config === void 0 ? void 0 : config.url) {
                if (isLogEventUrl(config.url)) {
                    if (!config.headers) {
                        config.headers = {};
                    }
                    config.headers['X-UI-Start-Timestamp'] = new Date().getTime().toString();
                }
            }
            return config;
        }, (error) => {
            return Promise.reject(error);
        });
        // log errors, do not process the event request url.
        config_1.axios.interceptors.response.use((response) => {
            var _a;
            if ((_a = response === null || response === void 0 ? void 0 : response.config) === null || _a === void 0 ? void 0 : _a.url) {
                if (isLogEventUrl(response.config.url)) {
                    logNetworkEvent(response).catch((error) => {
                        logger.log(`[monitoring-splunk] Error: logNetworkEvent(): ${error}`);
                    });
                }
            }
            return response;
        }, (error) => {
            const response = error.response;
            if (response) {
                if (response === null || response === void 0 ? void 0 : response.config) {
                    if (isLogEventUrl(response.config.url)) {
                        logNetworkEvent(response).catch((error) => {
                            logger.log(`[monitoring-splunk] Error: logNetworkEvent(): ${error}`);
                        });
                    }
                    else {
                        logger.log(`[monitoring-splunk] logNetworkEvent() ignoring url: ${response.config.url}`);
                    }
                }
            }
            return Promise.reject(error);
        });
    }))();
}
exports.setupAxiosInterceptors = setupAxiosInterceptors;
/**
 * Do not log events if they are present in a list of urls defined in the array constant
 * named <code>IGNORE_EVENT_LOGGING_URLS</code>.
 *
 * @param url
 * @returns true if the url should be logged to splunk.
 */
function isLogEventUrl(url) {
    let logEvent = true;
    if (url && url.trim().length > 0) {
        app_constants_1.IGNORE_EVENT_LOGGING_URLS.forEach(element => {
            if (url.indexOf(element) >= 0 && logEvent === true) {
                logEvent = false;
            }
        });
    }
    else {
        logEvent = false;
    }
    return logEvent;
}
exports.isLogEventUrl = isLogEventUrl;
/**
 * Method to populate the <code>CommWebEvent</code> for any network or service calls.
 * Create an event payload using available information.
 *
 * Event Payload is populated from the following:
 * - a) browser session storage
 * - b) vuex data store
 * - c) http response
 * - d) computed
 *
 * @param response contains http response information to populate into the <code>EventLog</code> payload.
 * @return a promise
 */
function logNetworkEvent(response) {
    return __awaiter(this, void 0, void 0, function* () {
        let path = null;
        let elapsedTime = 0;
        let event = {};
        event.message_type = app_constants_1.MESSAGE_NETWORK_TYPE;
        event = addUserInformation(event);
        if (response === null || response === void 0 ? void 0 : response.config) {
            if (response.config.headers && response.config.headers['X-UI-Start-Timestamp']) {
                const startTime = parseInt(response.config.headers['X-UI-Start-Timestamp'] + '', 10);
                if (!isNaN(startTime)) {
                    elapsedTime = new Date().getTime() - startTime;
                }
            }
            if (response.config.url) {
                // set the service url value in our path variable
                path = response.config.url;
                try {
                    path = decodeURI(new URL(path).pathname);
                }
                catch (error) {
                    // nothing if there is an unencoding error.
                }
            }
            // set computed values
            event.path = path;
            event.elapsed_time = elapsedTime;
            // set properties from http response
            event.method = (response.config.method || '').toLowerCase();
            event.status = response.status;
            // TODO: the uuid can be returned in different response params, identify these and search for a uuid.
            event.vendor_uuid = response.headers && response.headers[app_constants_1.VENDOR_UUID_HEADER];
            // Log the event to splunk by invoking a service call containing the event payload.
            try {
                return yield getEventLogService().logMessage(event);
            }
            catch (error) {
                return Promise.reject(new Error(`[monitoring-splunk] Error: ${event.message_type} EventLogService.logEvent()`));
            }
        }
    });
}
exports.logNetworkEvent = logNetworkEvent;
/**
 * Method to populate the <code>CommWebEvent</code> for any google analytics invocation.
 * Create an event payload using available information.
 *
 * Event Payload is populated from the following:
 * - a) browser session storage
 * - b) vuex data store
 *
 * @param trackObj google analytics event object
 * @return Promise
 */
function logAnalyticsEvent(trackObj) {
    return __awaiter(this, void 0, void 0, function* () {
        let event = {};
        event = addUserInformation(event);
        event.message_type = app_constants_1.MESSAGE_ANALYTICS_TYPE;
        event.event_type = app_constants_1.MESSAGE_GOOGLE_ANALYTICS_TYPE;
        let analyticsDataEvent = JSON.stringify(trackObj) || '';
        if (analyticsDataEvent && analyticsDataEvent.length > 0) {
            analyticsDataEvent = analyticsDataEvent.split('"').join(' ');
        }
        event.event_data = analyticsDataEvent;
        // these properties are not available when logging an analytics event
        event.elapsed_time = 0;
        // Log the event to splunk by invoking a service call containing the event payload.
        try {
            return yield getEventLogService().logMessage(event);
        }
        catch (error) {
            return Promise.reject(new Error(`[monitoring-splunk] Error: ${event.message_type} EventLogService.logEvent()`));
        }
    });
}
exports.logAnalyticsEvent = logAnalyticsEvent;
/**
 * Return an initialized instance of <code>EventLogService</code>.
 * @return initialized instance of <code>EventLogService</code>
 */
function getEventLogService() {
    return eventLogService;
}
/**
 * Create an instance of <code>EventLogService</code> based on an <code>apiConfig</code>.
 * @param EventLogService
 */
function setupEventLogService(apiConfig, commServicesAuthConfig) {
    eventLogService = new event_log_service_1.EventLogService(apiConfig, commServicesAuthConfig);
}
exports.setupEventLogService = setupEventLogService;
/**
 * Add user information from a data store, in this case browser session
 * @param event
 * @returns update event object
 */
function addUserInformation(event) {
    // get the previously stored event log values
    if (window.sessionStorage.getItem('eventLogData') !== null) {
        const eventData = sessionStorage.getItem('eventLogData') || '';
        const eventLog = JSON.parse(eventData);
        if (eventLog && 'object' === typeof eventLog) {
            event.comm_web_uuid = eventLog.commWebUuid; // uuid is used to track events during the members session.
            event.user_type = eventLog.userType;
            event.username = eventLog.userName;
            event.supported_profile = eventLog.supportedProfile || null;
            event.support_access_role = eventLog.supportAccessRole || null;
        }
    }
    return event;
}
//# sourceMappingURL=index.js.map